import { gql } from 'graphql-request';

export const CATEGORY_FRAGMENT = gql`
  fragment CategoryFragment on WishCategory {
    id: categoryId
    approved: categoryApproved
    title: categoryTitle
    originalLang: categoryOriginalLang
    wishCount: categoryWishCount
    colorHex
    descriptionDE
    descriptionEN
    image {
      id
      width
      height
      ... on wishApi_Asset {
        firstname
        lastname
        license
      }
      url @transform(width: 375, immediately: true, quality: 85, format: "webp")
      srcset(sizes: ["75", "150", "300", "600", "900"])
    }
  }
`;

export const WISH_FRAGMENT = gql`
  fragment WishFragment on Wish {
    id: wishId
    approved: wishApproved
    dirty
    baseId: wishBaseId
    categories: wishCategories
    client: wishClient
    curated: wishCurated
    installationName: wishInstallationName
    lat: wishLat
    lng: wishLng
    originalLang: wishOriginalLang
    placename: wishPlacename
    readOnly: wishReadOnly
    screenId: wishScreenId
    selectCount: wishSelectCount
    userAgeGroup: wishUserAgeGroup
    userGender: wishUserGender
    userResidence: wishUserResidence
    uuid: wishUuid
    wishedCount: wishWishedCount
    title: wishTitle
  }
`;
